import React from 'react';
import PropTypes from 'prop-types';
import InfoCard from '../../components/InfoCard/InfoCard';

require('./PaymentPreferance.scss');

const checkBoxDisabled = require('@images/checkbox_disabled.svg');
const checkBoxEnabled = require('@images/checkbox_enabled.svg');

const staticText = {
  refundCashback: 'Refund cash selected',
  peWalletSelected: 'Pharmeasy Wallet Selected',
  walletBalance: 'Wallet Balance ',
  refundBalance: 'Refund Balance'
};
const PaymentPreferance = props => {
  function getPaymentModeArray() {
    const {
      payment_modes: { options: otherOptions = [] } = {},
      preferred_options: { options: preferred_options = [] } = {},
      preferredOptions: { options: preferredOptions = [] } = {},
    } = props.paymentMethodsData;

    return [...preferredOptions, ...preferred_options, ...otherOptions];
  }

  const {
    selectedPaymentMode,
    selectPaymentMode,
    walletOpted,
    paymentMethodsData,
    optForWalletPayment,
    walletDetails,
    isWalletAsDiscountApplicable = false

  } = props;
  const { infoCard, applicableAmount } = walletDetails || {};
  if (!paymentMethodsData) {
    return null;
  }
  const paymentModes = getPaymentModeArray();
  const ufpAllowed = paymentMethodsData.ufp_active && paymentMethodsData.ufp_eligible;
  const ALLOW_WALLET_OPTIN = false;
  const activeWalletBalance = (<div className="applicableAmountContainer"><div className="walletBalance">{isWalletAsDiscountApplicable ? staticText.refundBalance : staticText.walletBalance}</div>{' '}<InfoCard infoCard={infoCard} /> <div> ₹{applicableAmount}
  </div></div>);

  return (
    <div className="PaymentPreferance">
      <div className="infoForCustomer hide">
        <div className="title">Convey this to consumer:</div>
        {ufpAllowed && <div className="infoText">Order is eligible for immediate payment</div>}
        {ufpAllowed && <div className="infoText">For online payment, link will be shared via SMS</div>}
        {!ufpAllowed && <div className="infoText">Payment can be done only after the bill is prepared</div>}
      </div>
      {+applicableAmount > 0 && (<div className={`walletOptIn ${ALLOW_WALLET_OPTIN ? '' : 'optInNotAllowed'}`} onClick={() => ALLOW_WALLET_OPTIN && optForWalletPayment(!walletOpted)}>
        <img className="walletIcon" src={require('@images/wallet.svg')} />
        <span className="title">{ALLOW_WALLET_OPTIN ? 'Use Pharmeasy Wallet' : isWalletAsDiscountApplicable ? staticText.refundCashback : staticText.peWalletSelected}</span>
        {activeWalletBalance}
        {ALLOW_WALLET_OPTIN && <img className="checkBox" src={walletOpted ? checkBoxEnabled : checkBoxDisabled} />}
      </div>)}
      <div className="paymentModeTitle">Select the mode of payment</div>
      <div className="paymentModesContainer">
        {paymentModes.map((paymentMode, index) => {
          const isSelected = selectedPaymentMode === `${paymentMode.payment_type_id}-${paymentMode.payment_sub_type_id || ''}`;

          const disabled = 'is_enabled' in paymentMode && !paymentMode.is_enabled;

          return (<div className="paymentModeOption" key={index} onClick={() => !disabled && selectPaymentMode(paymentMode)}>
            <img src={paymentMode.image} />
            <div className="pgInfo">
              <div className="pgName">{paymentMode.display_name}</div>
              <div className="pgDescription">{paymentMode.sub_text || paymentMode.offer_text || ''}</div>
            </div>
            <input type="radio" name="paymentMode" checked={isSelected} disabled={disabled} />
          </div>);
        })}
      </div>
    </div>
  );
};

PaymentPreferance.propTypes = {
  paymentMethodsData: PropTypes.object.isRequired,
  selectedPaymentMode: PropTypes.string,
  selectPaymentMode: PropTypes.func.isRequired,
  walletOpted: PropTypes.bool.isRequired,
  walletBalance: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  optForWalletPayment: PropTypes.func.isRequired,
  walletDetails: PropTypes.object,
};

PaymentPreferance.defaultProps = {
  walletDetails: null
};


export default PaymentPreferance;
